import { DatePipe } from '@angular/common';
import { Component, input, OnInit } from '@angular/core';
import { Activity, ActivityType } from '@context/shared/types/activity';
import { getName, User } from '@context/shared/types/user';
import { TranslocoModule } from '@jsverse/transloco';
import { TuiIcon } from '@taiga-ui/core';
import { DocumentReference, getDoc } from 'firebase/firestore';

const DefaultActivityIcon = '@tui.activity';
const ActivityIconMap: { [key in ActivityType]: string } = {
	archive: '@tui.archive',
	create: '@tui.circle-plus',
	delete: '@tui.trash',
	disable: '@tui.circle-minus',
	enable: '@tui.circle-check',
	'move-to': '@tui.folder-input',
	ownership: '@tui.user-cog',
	'revoke-ownership': '@tui.user-minus',
	'revoke-share': '@tui.user-round-x',
	share: '@tui.share-2',
	unarchive: '@tui.archive-restore',
	update: '@tui.pen-line',
	status: '@tui.trending-up',
	thumbnail: '@tui.image',
	'set-as-thumbnail': '@tui.image-plus',
	'remove-as-thumbnail': '@tui.image-minus',
	'create-external-link': '@tui.link',
	'remove-external-link': '@tui.unlink',
	restore: '@tui.rotate-ccw',
};

@Component({
	imports: [TranslocoModule, DatePipe, TuiIcon],
	selector: 'ctx-activity-row',
	templateUrl: 'activity-row.component.html',
	styleUrl: 'activity-row.component.scss',
})
export class ActivityRowComponent implements OnInit {
	readonly activity = input.required<Activity>();

	readonly user = input<User | null>(null);

	readonly label = input<string | null>(null);

	icon!: string;

	userName: string | null = null;
	currentUser: User | null = null;

	ngOnInit() {
		const activityValue = this.activity();
		this.icon = ActivityIconMap[activityValue.type] ?? DefaultActivityIcon;

		const userValue = this.user();
		if (userValue) {
			this.currentUser = userValue;
			this.userName = getName(userValue);
		} else if (activityValue.user) {
			getDoc(activityValue.user as DocumentReference<User>).then(
				(res) => {
					this.currentUser = res.data() as User;
					this.userName = getName(this.currentUser);
				},
			);
		}
	}
}
